import KeyboardCommandKeyOutlinedIcon from '@mui/icons-material/KeyboardCommandKeyOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';

const icons = {
  KeyboardCommandKeyOutlinedIcon,
  ManageHistoryOutlinedIcon
};

const control = {
  id: 'group-control',
  title: '출력제어',
  type: 'group',
  admin: false,
  outeradmin: false,
  children: [
    {
      id: 'control-command',
      title: '제어관리',
      type: 'item',
      url: '/control/default',
      icon: icons.KeyboardCommandKeyOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'control-history',
      title: '제어기록',
      type: 'item',
      url: '/control/history',
      icon: icons.ManageHistoryOutlinedIcon,
      breadcrumbs: false
    }
  ]
};

export default control;
